import { PayloadAction, createSelector } from '@reduxjs/toolkit';
import { DashboardReducerState } from './types';
import { RootState } from '../../../../store';
import { createExtendedSlice } from 'src/store/createExtendedSlice';
import { LogMsgFailed } from 'src/app/store/routingSlice/types';

const sliceName = 'dashboardView';

// 4 state statuses (assets / snapshot):
// 1. undefined === initial
// 2. null === fetching
// 3. empty array === no data
// 4. array with items === with data
const initialState: DashboardReducerState = {
  data: null,
};
// =============================
// ------- Slice ----------
// =============================
export const dashboardViewSlice = createExtendedSlice({
  name: sliceName,
  initialState,
  reducers: {
    // ---- Internal ---
    dashboardViewInit: (state) => {},
    dashboardViewFetchDashboardRequest: (state) => {},
    dashboardViewFetchDashboardSuccess: (
      state,
      { payload }: PayloadAction<DashboardReducerState['data']>,
    ) => {
      state.data = payload;
    },
    dashboardViewFetchDashboardFailed: (
      state,
      { payload }: PayloadAction<LogMsgFailed>,
    ) => {},
  },
});

// =============================
// ------- selectors ----------
// =============================
export const getDashboardViewData = (state: RootState) =>
  state.dashboardView.data;

export const getDashboardViewIsWithData = createSelector(
  getDashboardViewData,
  (data) => Boolean(data),
);
// expenses
export const getDashboardViewDataExpenses = createSelector(
  getDashboardViewData,
  (data) => data?.expenses ?? null,
);
export const getDashboardViewDataExpensesTimeSpan = createSelector(
  getDashboardViewDataExpenses,
  (data) => data?.timeSpan ?? null,
);
// receipts
export const getDashboardViewDataReceipts = createSelector(
  getDashboardViewData,
  (data) => data?.receipts ?? null,
);
export const getDashboardViewDataReceiptsTotal = createSelector(
  getDashboardViewDataReceipts,
  (data) => data?.total ?? null,
);
export const getDashboardViewDataReceiptsTimeSpan = createSelector(
  getDashboardViewDataReceipts,
  (data) => data?.timeSpan ?? null,
);
// status
export const getDashboardViewDataStatus = createSelector(
  getDashboardViewData,
  (data) => data?.status ?? null,
);
export const getDashboardViewDataStatusTimeSpan = createSelector(
  getDashboardViewDataStatus,
  (status) => status?.timeSpan ?? null,
);
export const getDashboardViewDataExpensesDataPoints = createSelector(
  getDashboardViewDataExpenses,
  (expenses) => expenses?.dataPoints ?? null,
);

// =============================
// ------- Exports ----------
// =============================

export const {
  dashboardViewInit,
  dashboardViewFetchDashboardRequest,
  dashboardViewFetchDashboardSuccess,
  dashboardViewFetchDashboardFailed,
} = dashboardViewSlice.actions;

export default dashboardViewSlice.reducer;
